class s {
  isSecure = !0;
  maxAgeInSeconds = 31536e3;
  maxAgeInDays;
  domain;
  sameSite;
}
class m {
  generateCookieString(t, e) {
    let o = `${t.cookieName}=${encodeURIComponent(
      t.cookieValue
    )}`;
    if (e.domain && (o = `${o};domain=${e.domain}`), e.maxAgeInDays) {
      const i = new Date();
      i.setTime(
        i.getTime() + e.maxAgeInDays * 24 * 60 * 60 * 1e3
      ), o = `${o};expires=${i.toUTCString()}`;
    } else
      o = `${o};max-age=${e.maxAgeInSeconds}`;
    return e.sameSite && (o = `${o};samesite=${e.sameSite}`), e.isSecure && (o = `${o};Secure`), o;
  }
}
class u {
  constructor(t = new m()) {
    this.stringGenerator = t;
  }
  getCookieByName(t) {
    const e = t + "=", o = document.cookie.split(";");
    for (const i of o) {
      const r = i.trimStart();
      if (r.indexOf(e) === 0) {
        const a = r.substring(
          e.length,
          r.length
        );
        return decodeURIComponent(a);
      }
    }
  }
  setCookie(t, e = new s()) {
    document.cookie = this.stringGenerator.generateCookieString(
      t,
      e
    );
  }
  removeCookie(t) {
    const e = new s();
    e.maxAgeInSeconds = 0;
    const o = {
      cookieName: t,
      cookieValue: ""
    };
    this.setCookie(o, e);
  }
  setCookieFromJSONObject = (t, e, o = new s()) => {
    if (t && e)
      try {
        const i = JSON.stringify(e), r = {
          cookieName: t,
          cookieValue: i
        };
        return this.setCookie(r, o), !0;
      } catch {
        return !1;
      }
    return !1;
  };
  getJSONObjectFromCookie = (t) => {
    const e = this.getCookieByName(t);
    if (e)
      try {
        const o = JSON.parse(e);
        return o && typeof o == "object" ? o : void 0;
      } catch {
        return;
      }
    else
      return;
  };
}
const c = new u();
function g(n) {
  return c.getCookieByName(n);
}
function k(n, t = new s()) {
  c.setCookie(n, t);
}
function C(n) {
  c.removeCookie(n);
}
function S(n) {
  return c.getJSONObjectFromCookie(n);
}
function f(n, t, e = new s()) {
  return c.setCookieFromJSONObject(
    n,
    t,
    e
  );
}
export {
  g as getCookieByName,
  S as getJSONObjectFromCookie,
  C as removeCookie,
  k as setCookie,
  f as setCookieFromJSONObject
};
//# sourceMappingURL=index.js.map
